(() => {
  document.querySelectorAll('[data-aura-product]').forEach((root) => {
    const select = root.querySelector('[data-aura-variant-select]');
    const form = root.querySelector('[data-aura-product-form]');
    const price = root.querySelector('[data-aura-price]');
    const add = root.querySelector('[data-aura-add]');
    const mobileAdd = root.querySelector('[data-aura-mobile-add]');
    const mobilePrice = root.querySelector('[data-aura-mobile-price]');
    const anonymousGift = root.querySelector('[data-aura-anonymous-gift]');
    const scarcity = root.querySelector('[data-aura-scarcity]');
    const inventoryCount = root.querySelector('[data-aura-inventory-count]');
    const archivePodWarning = root.querySelector('[data-aura-archive-pod-warning]');
    const bundleRadios = [...root.querySelectorAll('[data-aura-bundle-selector] input[name="aura-bundle"]')];
    const radios = [...root.querySelectorAll('.aura-dynamic-product__options input')];
    const variantsData = root.querySelector('[data-aura-variants]');
    const media = [...root.querySelectorAll('.aura-dynamic-product__media')];
    const thumbs = [...root.querySelectorAll('[data-media-target]')];
    if (!select || !form) return;

    const preorderLabel = (option) => {
      if (root.dataset.productHandle !== 'neural-interrupt-node') return 'ADD TO CART';
      if (option?.dataset.title === 'Desk + Pocket Set') return 'Pre-Order Desk + Pocket Set — $68';
      if (option?.dataset.title === 'Dual-Sensory Set') return 'Pre-Order Dual-Sensory Set — $68';
      return 'Pre-Order Batch 01 — $39';
    };

    const isLocalPreview = ['127.0.0.1', 'localhost', '::1'].includes(window.location.hostname);
    if (isLocalPreview) {
      [...media, ...thumbs].forEach((item) => {
        const source = item.dataset.localPreviewSrc;
        const image = item.querySelector('img');
        if (!source || !image) return;
        image.src = source;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
      });
      root.dataset.localMediaPreview = 'active';
    }

    let variants = [];
    try {
      variants = JSON.parse(variantsData?.textContent || '[]');
    } catch (error) {
      console.error('AuraSync variant data could not be parsed.', error);
    }

    const showMedia = (mediaId) => {
      const visibleMedia = media.filter((item) => !item.hidden);
      const target = visibleMedia.find((item) => item.dataset.mediaId === String(mediaId)) || visibleMedia[0];
      media.forEach((item) => item.classList.toggle('is-active', item === target));
      thumbs.forEach((item) => item.classList.toggle('is-active', item.dataset.mediaTarget === target?.dataset.mediaId));
    };

    const updateVariant = () => {
      const values = radios.filter((radio) => radio.checked).map((radio) => radio.value);
      const variant = variants.find((item) =>
        values.length === item.options.length &&
        values.every((value, index) => item.options[index] === value),
      );
      const option = variant
        ? [...select.options].find((item) => item.value === String(variant.id))
        : null;
      if (!option) return;
      select.value = option.value;
      showMedia(option.dataset.mediaId);
      price.textContent = option.dataset.price;
      if (mobilePrice) mobilePrice.textContent = option.dataset.price;
      if (archivePodWarning) {
        archivePodWarning.hidden = !option.dataset.title.includes('The Archive Presentation Matrix');
      }
      add.disabled = option.disabled;
      add.textContent = option.disabled ? 'CURRENTLY UNAVAILABLE' : preorderLabel(option);
      if (mobileAdd) {
        mobileAdd.disabled = option.disabled;
        mobileAdd.textContent = option.disabled ? 'CURRENTLY UNAVAILABLE' : preorderLabel(option);
      }
      const tracked = option.dataset.inventoryTracked === 'true';
      const availableQuantity = Number(option.dataset.inventoryQuantity || 0);
      if (scarcity) {
        scarcity.hidden = !(tracked && availableQuantity > 0 && availableQuantity < 20);
        if (inventoryCount) inventoryCount.textContent = String(availableQuantity);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    };

    radios.forEach((radio) => radio.addEventListener('change', updateVariant));
    const applyBundleChoice = (radio) => {
      const targetOption = [...select.options].find((option) => {
        if (radio.value === 'single') return option.dataset.title === 'Single';
        if (radio.value === 'dual-sensory') return option.dataset.title === 'Dual-Sensory Set';
        return option.dataset.title === 'Desk + Pocket Set';
      });
      if (targetOption) {
        select.value = targetOption.value;
        price.textContent = radio.dataset.auraBundlePrice;
        if (mobilePrice) mobilePrice.textContent = radio.dataset.auraBundlePrice;
        add.disabled = targetOption.disabled;
        add.textContent = preorderLabel(targetOption);
        if (mobileAdd) {
          mobileAdd.disabled = targetOption.disabled;
          mobileAdd.textContent = preorderLabel(targetOption);
        }
      }
      let property = form.querySelector('input[name="properties[Bundle Configuration]"]');
      if (!property) {
        property = document.createElement('input');
        property.type = 'hidden';
        property.name = 'properties[Bundle Configuration]';
        form.appendChild(property);
      }
      property.value = radio.value;
    };
    bundleRadios.forEach((radio) => radio.addEventListener('change', () => applyBundleChoice(radio)));
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaTarget)));

    if (root.dataset.productHandle === 'mineral-infusion-hydration-vessel' && !new URL(window.location.href).searchParams.has('variant')) {
      const first = media[0];
      media.forEach((item) => item.classList.toggle('is-active', item === first));
      thumbs.forEach((item) => item.classList.toggle('is-active', item.dataset.mediaTarget === first?.dataset.mediaId));
    } else {
      showMedia(select.options[select.selectedIndex]?.dataset.mediaId);
    }
    if (archivePodWarning) {
      archivePodWarning.hidden = !select.options[select.selectedIndex]?.dataset.title.includes('The Archive Presentation Matrix');
    }
    const initialBundleChoice = bundleRadios.find((radio) => radio.checked);
    if (initialBundleChoice) applyBundleChoice(initialBundleChoice);

    const submitProduct = async () => {
      if (add.disabled) return;
      const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
      const original = add.textContent;
      add.disabled = true;
      if (mobileAdd) mobileAdd.disabled = true;
      add.classList.add('is-pressing');
      mobileAdd?.classList.add('is-pressing');
      window.AuraSyncUI?.setLoading(true);
      try {
        const bundleChoice = bundleRadios.find((radio) => radio.checked)?.value;
        const items = [{ id: Number(select.value), quantity, properties: bundleChoice ? { 'Bundle Configuration': bundleChoice } : {} }];
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.description || payload.message || 'Unable to add this object.');
        }
        add.textContent = 'Added to cart';
        if (mobileAdd) mobileAdd.textContent = 'Added to cart';
        window.AuraSyncUI?.showToast(quantity);
        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('[data-aurasync-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
        }
        // Reuse the existing Horizon drawer for every product, not only Anchor.
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}?sections=cart-drawer-section`);
          const sections = await response.json();
          const container = document.getElementById('shopify-section-cart-drawer-section');
          if (container && sections['cart-drawer-section']) {
            container.outerHTML = sections['cart-drawer-section'];
            document.getElementById('cart-drawer')?.open?.();
          }
        } catch (_) { /* The item is already added; the cart link remains available. */ }
        window.setTimeout(() => {
          add.textContent = original;
          if (mobileAdd) mobileAdd.textContent = preorderLabel(select.options[select.selectedIndex]);
        }, 2000);
      } catch (error) {
        add.textContent = error.message;
        window.setTimeout(() => { add.textContent = original; }, 1800);
      } finally {
        add.disabled = select.options[select.selectedIndex].disabled;
        if (mobileAdd) mobileAdd.disabled = select.options[select.selectedIndex].disabled;
        add.classList.remove('is-pressing');
        mobileAdd?.classList.remove('is-pressing');
        window.AuraSyncUI?.setLoading(false);
      }
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      submitProduct();
    }, true);
    mobileAdd?.addEventListener('click', submitProduct);

    anonymousGift?.addEventListener('click', async () => {
      if (anonymousGift.disabled || select.options[select.selectedIndex].disabled) return;
      const original = anonymousGift.textContent;
      anonymousGift.disabled = true;
      window.AuraSyncUI?.setLoading(true);
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: Number(select.value),
              quantity: 1,
              properties: { 'Gift Type': 'Anonymous Gift' },
            }],
          }),
        });
        if (!response.ok) throw new Error('Unable to add this anonymous gift.');
        anonymousGift.textContent = '✓ ANONYMOUS GIFT ANCHORED';
        window.AuraSyncUI?.showToast(1);
        const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('[data-aurasync-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
        }
        window.setTimeout(() => { anonymousGift.textContent = original; }, 2200);
      } catch (error) {
        anonymousGift.textContent = error.message;
        window.setTimeout(() => { anonymousGift.textContent = original; }, 1800);
      } finally {
        anonymousGift.disabled = false;
        window.AuraSyncUI?.setLoading(false);
      }
    });

    const overloadToast = document.querySelector('[data-aura-product-overload-toast]');
    let overloadIdleTimer;
    let overloadHideTimer;
    let overloadShownSinceScroll = false;

    const hideOverloadToast = () => {
      document.documentElement.classList.remove('aura-product-overload-active');
      overloadToast?.classList.remove('is-visible');
      overloadToast?.setAttribute('aria-hidden', 'true');
    };

    const showOverloadToast = () => {
      if (!overloadToast || overloadShownSinceScroll) return;
      overloadShownSinceScroll = true;
      document.documentElement.classList.add('aura-product-overload-active');
      overloadToast.classList.add('is-visible');
      overloadToast.setAttribute('aria-hidden', 'false');
      window.clearTimeout(overloadHideTimer);
      overloadHideTimer = window.setTimeout(hideOverloadToast, 4000);
    };

    const armOverloadToast = () => {
      window.clearTimeout(overloadIdleTimer);
      overloadShownSinceScroll = false;
      hideOverloadToast();
      overloadIdleTimer = window.setTimeout(showOverloadToast, 30000);
    };

    window.addEventListener('scroll', armOverloadToast, { passive: true });
    armOverloadToast();
  });
})();
